import React from 'react'
import { Popconfirm } from 'antd'
import styles from './index.module.less'

interface IProps {
  description?: string
  onConfirm?: () => void
  onCancel?: () => void
  children: React.ReactNode
}

const PopConfirm = ({
  description,
  onConfirm,
  onCancel,
  children,
  ...props
}: IProps) => {
  return (
    <Popconfirm
      title={null}
      description={<span className={styles.desc}>{description}</span>}
      icon={null}
      okButtonProps={{ classNames: styles.okBtn }}
      cancelButtonProps={{ classNames: styles.cancelBtn }}
      onConfirm={(e) => {
        typeof onConfirm === 'function' && onConfirm()
      }}
      onCancel={(e) => {
        typeof onCancel === 'function' && onCancel()
      }}
      {...props}
    >
      {children}
    </Popconfirm>
  )
}

export default PopConfirm
